export const paymentHistoryConstants = {
	GET_PAYMENT_HISTORY_REQUEST: 'GET_PAYMENT_HISTORY_REQUEST',
	GET_PAYMENT_HISTORY_SUCCESS: 'GET_PAYMENT_HISTORY_SUCCESS',
	GET_PAYMENT_HISTORY_FALIURE: 'GET_PAYMENT_HISTORY_FALIURE',

	GET_PAYMENT_HISTORY_PDF_REQUEST: 'GET_PAYMENT_HISTORY_PDF_REQUEST',
	GET_PAYMENT_HISTORY_PDF_SUCCESS: 'GET_PAYMENT_HISTORY_PDF_SUCCESS',
	GET_PAYMENT_HISTORY_PDF_FALIURE: 'GET_PAYMENT_HISTORY_PDF_FALIURE'
};
